<template>
  <div class="taskOutcome">
    <b-input-group>
      <b-form-select v-if="dataslot.property.type.__type=='String'"
        v-model="value" :options="dataslot.property.allowedValues"  :id="dataslot.id" :name="dataslot.id" :class="highlight()"  v-on:change="handleBlur()" :state="inputState()">

      </b-form-select>

      <b-button variant="light" v-if="value"><b-icon variant="danger" icon="backspace" @click="clearInput()"></b-icon></b-button>

      <b-button variant="light" v-if="showSave"><b-icon variant="danger" icon="cloud-upload" @click="saveSlot()"></b-icon></b-button>

    </b-input-group>
  </div>
</template>

<script>
export default {
  name: 'ManualTaskOutcome',
  props: ['dataslot'],
  data() {
    return {
      value: '',
      showSave: false,
      selected: null,
      options: []
    };
  },
  computed: {
    dialogState () {
      return this.$store.state.dialogState;
    },
  },
  methods: {
    inputState() {
      if( this.value )
        return true;
      else if ( this.dataslot.property.mandatory )
        return false;

      return null;
    },
    highlight() {
      if(this.dialogState && this.dialogState.currentDialogueTurn && this.dialogState.currentDialogueTurn.modifiedSlots) {
        for ( var s in this.dialogState.currentDialogueTurn.modifiedSlots ) {
          if(this.dataslot.id == this.dialogState.currentDialogueTurn.modifiedSlots[s].id) {
            return 'highlight';
          }
        }
      }
      return '';
    },
    clearInput() {
      this.value = '';
      this.handleBlur();
    },
    handleBlur() {
      if( this.dataslot &&  this.dataslot.userValue && this.value != this.dataslot.userValue.value) {
        this.showSave = true;
      } else if (this.dataslot && !this.dataslot.userValue && this.value) {
        this.showSave = true;
      } else {
        this.showSave = false;
      }
    },
    saveSlot() {
      this.showSave = false;
      this.$store.dispatch('saveSlot', { 'id': this.dataslot.id , 'value': this.value});
    }
  },
  created() {
    if( this.dataslot && this.dataslot.userValue )
      this.value = this.dataslot.userValue.value;
    else
      this.value = '';
  },
  watch: {
    dataslot: function(newVal) {
      // set value
      if( newVal && newVal.userValue )
        this.value = newVal.userValue.value;
      else
        this.value = '';

    }
  }
}
</script>

<style scoped>
  .taskOutcome {
    width: 100%;
  }
</style>
